import { render, staticRenderFns } from "./panels.vue?vue&type=template&id=eb97e246&scoped=true"
import script from "./panels.vue?vue&type=script&lang=ts"
export * from "./panels.vue?vue&type=script&lang=ts"
import style0 from "./panels.vue?vue&type=style&index=0&id=eb97e246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb97e246",
  null
  
)

export default component.exports